module.exports = __webpack_public_path__ + "img/envelope.2c111a3d.svg";